import type { Route } from "../../../../../utils/models/Route";
import type { UndoCommand, CommandContext } from "../types";

/**
 * Command for a locked-mode INTERIOR marker drag (see
 * store/modules/actions/locked-boundary-drag.ts's applyLockedMarkerDrag):
 * replays a full markers/lineStrings snapshot for the one affected route.
 * Unlike MoveLockedBoundaryCommand, there's no state.lockedBoundaries entry
 * to restore — an interior control point doesn't occupy a boundary slot.
 */
export class MoveLockedMarkerCommand implements UndoCommand {
  readonly type: string = 'MOVE_LOCKED_MARKER';
  readonly routeKey: string;

  private before: Route;
  private after: Route;

  constructor(payload: { routeKey: string; before: Route; after: Route }) {
    this.routeKey = payload.routeKey;
    this.before = JSON.parse(JSON.stringify(payload.before));
    this.after = JSON.parse(JSON.stringify(payload.after));
  }

  undo(ctx: CommandContext): void {
    this.apply(ctx, 'before');
  }

  redo(ctx: CommandContext): void {
    this.apply(ctx, 'after');
  }

  private apply(ctx: CommandContext, direction: 'before' | 'after'): void {
    const route = ctx.state.routes[this.routeKey];
    if (!route) return;

    const snapshot = direction === 'before' ? this.before : this.after;
    route.markers = JSON.parse(JSON.stringify(snapshot.markers));
    route.lineStrings = JSON.parse(JSON.stringify(snapshot.lineStrings));
    route.updated_at = new Date();
    ctx.state._statsVersion++;
  }
}
